module.exports = __webpack_public_path__ + "static/media/Amrut _Cup_2025_Rule_Book.aeb072ad.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Amrut _Cup_2025_Rule_Book.pdf
// module id = 672
// module chunks = 0